import { VIEW_MAP } from '../constant/index'
import { capitalize } from './string'

function toURL(params) {
  params = Object.entries(params).map(([key, value]) => {
    key = encodeURIComponent(key)
    value = encodeURIComponent(value)
    return `${key}=${value}`
  }).join('&')
  return params ? `?${params}` : ''
}

export default {
  // TODO: need unit test
  parse(path) {
    // remove leading slash
    path = path.substr(1).split('/')
    if (path.length === 1) {
      // e.g. /name
      return {
        prefix: '',
        viewMode: VIEW_MAP.LIST,
        name: path
      }
    } else if (path.length === 2) {
      if (['add', 'edit', 'detail'].includes(path[1])) {
        // e.g. /name/add
        return {
          prefix: '',
          viewMode: VIEW_MAP[path[1].toUpperCase()],
          name: path[0]
        }
      } else {
        // e.g. /prefix/name
        return {
          prefix: `${path[0]}`,
          viewMode: VIEW_MAP.LIST,
          name: path[1]
        }
      }
    } else if (path.length === 3) {
      if (['add', 'edit', 'detail'].includes(path[2])) {
        if (/Add$/.test(path[1]) || /Edit$/.test(path[1]) || /Detail$/.test(path[1])) {
          // e.g. /name/subAdd/add
          return {
            prefix: '',
            viewMode: VIEW_MAP[path[1].match(/(Add|Edit|Detail)$/)[1].toUpperCase()],
            name: path[0],
            subName: path[1].replace(/(Add|Edit|Detail)$/, ''),
            from: path[2]
          }
        } else {
          // e.g. /prefix/name/add
          return {
            prefix: `${path[0]}`,
            viewMode: VIEW_MAP[path[2].toUpperCase()],
            name: path[1]
          }
        }
      } else {
        // e.g. /prefix1/prefix2/name
        return {
          prefix: `${path[0]}/${path[1]}`,
          viewMode: VIEW_MAP.LIST,
          name: path[2]
        }
      }
    }
  },
  current(vm, viewMode, row, router, route) {
    const name = vm.viewInfo.name
    const re = new RegExp(`(.*)/(?=${name})`)
    const prefix = (route.path.match(re) || [])[1] || ''
    const keys = vm.viewInfo.hiddenKeys[name]
    const params = {}
    keys.forEach(key => params[key] = row[key])
    router.push(`${prefix}/${name}/${viewMode}` + toURL(params))
  },
  into(vm, subName, viewMode, row, router, route) {
    const name = vm.viewInfo.name
    const re = new RegExp(`(.*)/(?=${name})`)
    const prefix = (route.path.match(re) || [])[1] || ''
    const currentViewMode = route.params.view || 'list'
    const keys = vm.viewInfo.hiddenKeys[subName]
    const params = {}
    keys.forEach(key => params[key] = row[key])
    router.push(`${prefix}/${name}/${subName}${capitalize(viewMode)}/${currentViewMode}` + toURL(params))
  },
  back(vm, router, route) {
    const name = vm.viewInfo.name
    const re = new RegExp(`(.*)/(?=${name})`)
    const prefix = (route.path.match(re) || [])[1] || ''
    const viewMode = route.params.from
    router.push(`${prefix}/${name}` + ((viewMode && viewMode !== 'list') ? `/${viewMode}` : ''))
  }
}



// WEBPACK FOOTER //
// ./packages/utils/routerKit.js